/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-01-07 15:47:53
 */
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
    // 报告列表
    reportList: {
        // 隐私协议
        privacyAgreement: {
            title: '隐私协议',
            detail: {
                1: '我们向您承诺',
                2: '本隐私政策规定了Visbody及其关联公司（以下简称 "Visbody"，"我们"）如何收集、使用、披露、处理和保护您在使用我们的产品和服务时为我们提供的信息；如果我们要求您在使用产品和服务时提供某些信息以验证您的身份，我们将仅在严格遵守本隐私政策和/或我们的用户条款的情况下使用这些信息。',
                3: '本隐私政策是考虑到您的需求而制定的；您必须充分了解我们的个人数据收集和使用方法，并确信您对提供给Visbody的个人信息拥有最终控制权。',
                4: '在本隐私政策中，"个人信息 "指的是信息本身或数据，可以识别特定的个人后，结合其他信息的个人，可以由Visbody访问。通过使用Visbody产品和服务，您同意您已经阅读，承认并接受本隐私政策中描述的所有条款，包括我们在任何时间做出的任何更改。我们致力于保护您的个人信息的隐私性、保密性和安全性，并遵守适用的法律，包括您当地的数据保护条例。同时，我们承诺，我们所有的员工和代理人都会履行这些义务。'
            },
            bold: [
                '一、 我们如何收集和使用您的信息？',
                '1. 收集信息的类别',
                '为了向您提供我们的服务，我们可能会收集、存储和使用您自愿提供的以下信息，以及您的电脑、手机、平板电脑、控制台或其他设备（统称 "设备"）或浏览器自动提供的信息，如果您拒绝提供，我们可能无法向您提供我们的产品或服务。',
                '1.1 您提供的信息',
                '1.1.1 您在注册账户或使用本公司服务时向本公司提供的相关个人信息，如您的姓名、性别、年龄、身高、形象、电子邮件地址、电话号码、生物识别数据、个人资料和签名等。',
                '1.1.2 您通过我们的服务向其他方提供的共享信息，以及您在使用我们的服务时上传、提交、存储、发送或接收的信息。',
                '1.1.3 我们可能会使用Visbody账户和服务令牌来识别不同的用户。',
                '1.2 我们在您使用服务期间获得的信息',
                '我们会收集有关您使用的服务以及您如何使用这些服务的信息，如注册创建账户、使用平台更新您的信息、查询平台情况、使用Visbody硬件产品或服务等。这些信息包括',
                '1.2.1 设备信息。我们会根据您安装和/或使用软件的特定权限，接收并记录您正在使用的设备信息，如您的设备型号、设备类型、操作系统版本、设备设置、移动设备版本、设备识别码、屏幕分辨率、设备环境等软硬件功能信息，设备位置相关信息，如IP地址、GPS位置，以及可提供相关信息的传感器信息，如WLAN接入点、蓝牙、基站等。如果您在安装和/或使用过程中拒绝授予我们相应的权限，我们将不会记录您的上述相应信息。',
                '1.2.2 使用Visbody设备产生的数据：您的体重、BMI、脂肪、肌肉、含水量等身体数据，左上臂、右上臂、胸部、腰部、左大腿、右大腿、左腿、右腿、臀部等体围数据，颈椎屈曲、颈椎伸展、左颈椎屈曲、右颈椎屈曲、左颈椎旋转、右颈椎旋转等颈椎功能评估、3D模型。',
                '1.2.3 网络使用数据：我们可能会收集与Visbody设备、平板电脑、浏览器特定功能相关的网络类型、网络信号、IP地址等。',
                '1.2.4 相机和相册权限：当您上传图片时，我们会根据您拍摄/读取的图片，访问您设备相机的相关权限，收集您提供给我们的图片和视频信息。',
                '1.2.5 Cookie；像素标签。 平台用于收集使用信息的技术包括但不限于：cookies（当设备用于访问平台时放置在设备上的数据文件）、移动分析软件和像素标签（放置在网页或电子邮件中的透明图形图像，有时也称为网络信标或跟踪信标，用于指示某网页或电子邮件已被浏览）。 Cookies也可能用于将您与社交网站联系起来，如果您选择这样做，则可实现您在平台上的活动与您在此类社交网站上的活动之间的互动。 我们或我们的供应商可能会出于安全目的在您的设备上放置cookies或类似文件，以方便网站导航，并在使用我们的平台时使您的体验个性化（例如，允许我们根据您的兴趣、偏好、位置或人口统计信息选择哪些内容、广告或报价最有可能吸引您）。 像素标签可能会告诉您的浏览器从其他服务器获取内容。',
                '要了解如何减少您收到的cookie数量，或删除已经安装在您浏览器cookie文件夹中的cookie，请参考您浏览器的帮助菜单或其他与您浏览器相关的说明。 您也可以通过访问https://ico.org.uk/for-the-public/online/cookies，了解更多关于cookies的信息，其中包括关于cookies的其他有用信息以及如何使用不同类型的浏览器阻止cookies。',
                '1.2.6 谷歌分析。 我们使用一个名为 "Google Analytics "的工具来收集您的互联网使用信息。 例如，您访问我们网站的频率，您访问的网页，以及您在访问我们网站之前可能访问过的其他网站。 我们使用 "谷歌分析 "来深入了解平台的使用情况，并帮助我们改进产品和服务。虽然Google Analytics在您的网络浏览器上植入了一个永久性的cookie，以便在您下次访问本网站时将您识别为一个独特的用户，但除了Google之外，任何人都不能使用该cookie。 要退出Google Analytics，请使用Google的退出工具：https://tools.google.com/dlpage/gaoptout。',
                '',
                '',
                '2. 我们如何使用您的信息',
                '收集个人信息的目的是为了向您提供产品和/或服务，并确保我们遵守适用法律。您在此同意向我们的关联公司（涉及通信、社交媒体、技术和云业务）、第三方服务提供商（定义见下文）披露个人信息，但前提是我们将在本隐私政策的范围内处理您的个人信息。我们可能会将您的个人信息用于以下目的。',
                '2.1 Visbody账户注册。当注册一个Visbody账户时，所填写的信息将用于建立您的Visbody账户，并在平板电脑、浏览器或纸质报告中显示相关数据。',
                '2.2 物理数据的测量和计算。我们将利用个人基本信息结合Visbody云端测量计算出身体数据，在平板电脑、浏览器或纸质报告中显示，如BMI、脂肪、肌肉、体型、内脏脂肪、BFMI、肥胖程度、基础代谢、含水量、脂肪重量、蛋白质、骨量、无脂肪重量等。',
                '2.3 体围数据测量与计算.我们将利用个人基本信息结合Visbody云测量计算出左上臂、右上臂、胸部、腰部、左大腿、右大腿、左腿、右腿、臀部等体围数据，在平板电脑、浏览器或纸质报告中显示。',
                '2.4 颈椎功能评估与计算.我们将利用个人基本信息结合Visbody云端测量计算出颈椎屈曲、颈椎伸展、左颈椎屈曲、右颈椎屈曲、左颈椎旋转、右颈椎旋转等周长数据，在平板电脑、浏览器或纸质报告中显示。',
                '2.5 身体、体围或脑功能状况分析。根据您提供的个人资料和设备测量和记录的数据，我们将为您提供与您的身体、体围或脑功能状况相关的分析，供您参考。例如，根据您的个人信息和身体成分数据，我们将为您提供一个理想体重范围，供您参考，并进行综合身体评分。',
                '2.6 呼入电话信息显示。当您收到来电或短信时，设备将显示来电或信息数据。',
                '2.7 提供网络相关服务。Visbody在用户需要下载时，会根据不同的网络类型、网络信号等信息进行提示，具有一定的流量。',
                '2.8 统计分析。我们会对服务或设备的状况进行统计分析，并可能会将这些统计数据与公众或第三方共享，以呈现我们产品或服务的使用趋势，并对我们的产品和服务进行优化，如呈现某些排名榜单。',
                '2.9 消息推送与设备信息，如提醒、服务信息推送、订单状态、称重信息和社区新闻等。',
                '3. 我们如何使用cookies和类似技术',
                'Cookies和类似的技术是互联网上常见的技术。当您使用Visbody相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以便在您访问和使用Visbody时收集和存储信息。我们使用cookies和类似技术主要是为了实现以下功能或服务。',
                '3.1 确保产品和服务的安全、高效运行。我们可能会设置cookies或匿名标识符进行身份验证和安全保护，以使我们能够确认您是否安全登录服务或是否遇到盗窃、欺诈等非法行为。这些技术也将帮助我们提高服务效率，缩短登录和响应时间。',
                '3.2 为了帮助您获得更便捷的访问体验。',
                '使用此类技术可以帮助您避免重复填写个人信息和输入搜索内容的步骤和过程，实现一键登录和记录搜索历史。',
                '3.3 为您推荐、展示和推送您可能感兴趣的内容。',
                '我们可能会使用cookies和类似技术来了解您的偏好和使用习惯，并进行咨询或数据分析，以改善产品服务和用户体验。',
                '二、数据共享 数据共享',
                '我们不会与Visbody以外的任何公司、组织或个人分享您的个人信息，但以下情况除外。',
                '1.事先授权分享：在您明确同意或事先获得授权的情况下分享您的个人信息，如苹果健康。',
                '2.法律情况下的共享：根据适用法律法规、法律程序、强制性行政或司法要求，对外共享您的个人信息。',
                '3.与关联公司共享：我们可能会与关联公司共享您的个人信息，但我们只会共享必要的个人信息，并受本隐私政策所述目的的约束。如果我们的关联公司想要改变处理您的个人信息的目的，我们需要再次征求您的同意。',
                '4.与合作伙伴等第三方共享：当您在Visbody上购买商品或服务时，我们可能会与合作伙伴等第三方共享您的订单信息、账户信息、设备信息和位置信息，以确保向您提供的服务顺利完成。例如，当您在Visbody上购买商品时，我们必须与我们的物流服务商共享您的个人信息，以安排送货或安排合作伙伴提供服务。但是，我们只会在合法、正当、必要、特定和明确的目的下分享您的个人信息，并且只分享提供服务所必需的个人信息。我们的合作第三方服务商无权将共享的个人信息用于其他任何目的。我们的合作方包括以下几种类型。',
                '4.1 商品或服务的供应商。我们可能会与支持我们业务的供应商、服务提供商和其他合作伙伴共享您的个人信息，包括为我们提供或提供技术基础设施服务、提供客户服务、物流配送服务、支付服务和数据处理。我们分享您的个人信息是为了实现我们产品和/或服务的核心购物功能。',
                '4.2 第三方商户。为了满足您向第三方商户购买商品或服务的需求，并使其能够完成后续的售后服务，我们必须与第三方商户共享您的订单信息及与交易相关的必要信息。',
                '4.3 委托我们进行推广的合作伙伴。我们可能会代表其他企业向用户群体提供我们的产品和/或服务的推广服务。但我们只会向这些合作伙伴提供推广范围和效果的信息，而不会提供您的个人身份信息，或者我们会对这些信息进行汇总，以避免识别您的个人身份。例如，我们可能会向合作伙伴提供无法识别个人身份的统计数据，以帮助他们了解其受众或客户。我们将与与我们共享您的个人信息的公司、组织和个人签订严格的数据保护协议，并要求他们填写安全问卷，并按照我们的指示、本隐私政策和任何其他相关的保密和安全措施处理您的个人信息。',
                '4.4 保存政策',
                '本公司在实现其收集目的或遵守适用法律的要求或许可的情况下，将始终保留个人信息。我们将不再保留个人信息，或消除与特定个人相关联的手段，只要可以合理地推断出保留个人信息不符合收集目的。',
                '三、我们如何使用您的信息 我们如何使用您的信息',
                '1.为了保证您的信息安全，我们将努力采取合理的物理、电子和行政安全措施，按照现行行业标准保护您的信息，并尽一切合理的努力防止您的信息泄露或损坏或丢失，包括但不限于SSL、信息加密存储、数据中心访问控制。对您的个人信息的访问仅限于那些需要处理您的个人信息以完成任务或根据本隐私政策进行技术维护的人员。',
                '2.虽然我们已经采取了上述合理有效的措施，并遵守了相关法律要求的标准，但由于技术限制和可能存在的恶意手段，在互联网行业，即使我们尽最大努力加强安全措施，也不一定能保证信息的100%安全。我们将尽最大努力保证您提供的个人信息的安全。您承认并理解，您访问我们服务的系统和通信网络可能会因为我们无法控制的因素而出现问题。因此，我们强烈建议您采取积极措施保护您的个人信息，包括但不限于使用复杂的密码，定期更换密码，不向他人透露您的账号和密码。',
                '3.我们将制定应急预案，一旦发生用户信息安全事件，将立即启动应急预案，努力防止该安全事件的影响和后果扩大。如果不幸发生用户信息安全事件，我们将按照法律法规的要求及时告知您以下事项：安全事件的基本情况和可能造成的影响，我们已经或即将采取的处置措施，对您自主防范和降低风险的建议，对您的补救措施等。我们将通过电子邮件、信函、电话、推送通知或其他方式及时将事件的相关情况告知您。当难以通知到每一位个人信息主体时，我们将采取合理、有效的方式进行公告。同时，我们也将按照监管部门的要求，主动提交个人信息安全事件的处置条件。',
                '四、信息收集与使用 未成年人信息的收集和使用',
                '1.未成年人使用Visbody科技的产品或服务，必须得到其法定监护人的许可和指导。',
                '2.如果您是未成年人，您需要确保在提供个人信息前已获得法定监护人的同意。',
                '五、本隐私政策的修订',
                '虽然本隐私声明描述了Visbody科技在保护隐私方面所坚持的标准，但这些标准可能会发生变化。',
                '我们可能会改变我们的隐私惯例，当我们这样做，我们将更新这个页面，所以一定要定期检查它。',
                '我们可能会更新本隐私政策，以反映我们信息实践的变化。 如果我们做出任何重大变更，我们将在变更生效前向您发出显著通知。 我们鼓励您定期查看本页面，以获得有关我们隐私惯例的最新信息。'
            ]
        }
    },
    // 登录页面
    login: {
        loginAndRegister: '注册/登录',
        registerAndLogin: '登录/注册',
        userLogin: '用户登录',
        title: '手机账号和邮箱账号互相独立，请注意您的账号类型。',
        mobileLogin: '手机',
        emailLogin: '邮箱',
        email: 'E-mail',
        loginBtn: '登录',
        autoLogin: '下次自动登录',
        retransmission: '秒后重发',
        formList: [
            {
                label: '请输入手机号码',
                placeholder: '获取验证码'
            },
            {
                label: '验证码',
                placeholder: '请输入验证码'
            },
            {
                label: '请输入邮箱'
            }
        ],
        btn: {
            submit: '创建新账号',
            title: '真实的信息非常重要，请仔细填写'
        },
        rule: {
            phone: {
                requiredMsg: '手机号格式不正确',
                patternMsg: '手机号未注册，请创建新账号'
            },
            authCode: {
                requiredMsg: '验证码错误，请重新填写'
            },
            email: {
                requiredMsg: '邮箱格式不正确',
                patternMsg: '邮箱未注册，请创建新账号'
            }
        },
        codeSuccess: '验证码已发送，请查收',
        success: '发送成功',
        error: '发送失败',
        loginSuccess: '登录成功'
    },
    // 注册页面
    register: {
        mobileRegister: '手机注册',
        emailRegister: '邮箱注册',
        enroll: '手机号已注册',
        enrollEmail: '邮箱已注册',
        search: '搜索',
        title: '手机账号和邮箱账号互相独立，请注意您的账号类型。',
        needRead: {
            agree: '我已阅读并同意',
            privacy: '《用户隐私协议》'
        },
        register: '注册',
        check: '勾选“用户隐私协议”',
        newUser: '新用户注册',
        form: {
            labelList: ['姓名', '* 性别', '* 身高', '* 年龄']
        },
        placeholder: ['请输入姓名', '请输入你的身高', '请输入你的年龄'],
        unit: ['公制', '英制', '岁'],
        sexOptions: {
            male: '男',
            female: '女'
        },
        btn: '提交',
        rules: {
            metricheight: ['允许测量的身高范围是 2ft3in-6ft7in，请重新输入'],
            heightMsg: ['允许测量的身高范围是 70-200cm，请重新输入'],
            ageMsg: ['允许测量的年龄范围 10-99岁，请重新输入'],
            agePointMsg: ['填写了非整数：年龄只能为整数，请填写正确的年龄']
        },
        success: '注册成功',
        userMessage: '请输入用户名',
        verify: '请输入4位数的验证码',
        errorMsg: '允许输入的身高格式不支持小数，请重新输入'
    },
    // 模型合成
    model: {
        loading: '模型生成中，请您稍候',
        modelLoading: '模型加载中...',
        tabPane: [
            {
                title: '深度实感技术',
                msg: '通过三维扫描准确采集身体局部细节，保证围度测量的毫米级精度，让健身后的体型变化清晰呈现'
            },
            {
                title: 'BDA 体成分算法',
                msg:
                    '维塑采用最前沿的人体成分测算体系--BDA 算法确定人体成分，这项基于身体体积的测算方式将更精确地评估肥胖带来的健康风险。'
            },
            {
                title: '误差产生因素',
                msg:
                    '宽松的着装、身上的异物等都会导致不同程度的误差，如您想获取最精确的数据，请您穿着紧身衣或减少身上的衣物。'
            },
            {
                title: '报告入口',
                msg: '建议收藏网页，方便日后查看报告。稍后您也可将此报告发送至邮箱保存。'
            }
        ],
        collect: ['请收藏本网页，', '方便日后查看报告。'],
        know: '我知道了',
        reminder: [
            '温馨提示',
            '您的三维模型已生成，可尝试左右滑动来旋转模型。',
            '您的报告已生成，可点击“查看报告”按钮查看。',
            '您的体态评估未成功，请查看体成分报告。',
            '您的身体成分未成功，请查看体态评估报告。',
            '您的测量未成功，请到设备端重新体验哦~',
            '身体成分未成功，请到设备端重新体验哦~',
            '体态评估未成功，请到设备端重新体验哦~'
        ],
        btn: {
            viewReport: '查看报告',
            bodyReport: '查看体成分报告',
            postureReport: '查看体态报告',
            lastReport: '查看上次报告',
            loading: '加载中...'
        }
    },
    // 报告
    report: {
        btn: {
            download: '下载报告',
            send: '发送报告',
            report: '报告'
        },
        reportSuccess: '报告生成成功',
        tabPane: {
            labelList: ['测量时间', '测量项目', '身体成分', '体态评估', '肩部功能']
        },
        sendEmail: '发送至邮箱:',
        requiredMsg: '请输入你的邮箱地址',
        patternMsg: '请输入正确的邮箱',
        send: '发送',
        download: '下载报告',
        sendReport: '发送报告'
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: '性别修改成功',
            height: '身高修改成功',
            age: '年龄修改成功'
        },
        logOut: '退出登录',
        personal: '个人中心',
        cut: '切换单位/语言',
        changeSort: '切换产品报告',
        describe: '* 切换产品型号后，将为您展示对应产品型号下的所有测量报告。',
        describeBtn: '产品型号切换后，将为您跳转到该产品型号下的最新测量报告。',
        descReport: '产品报告切换成功',
        unit: ['公制 (kg, cm)', '英制 (ft, in, lb)'],
        read: {
            reading: '阅读',
            privacy: '《用户隐私协议》'
        },
        setting: '设置',
        form: {
            labelList: ['手机号码', '单位', '语言', '昵称', '性别', '身高', '年龄']
        },
        placeholder: ['修改昵称', '性别修改', '身高修改', '年龄修改'],
        btn: {
            cancelBtn: '取消',
            accomplishBtn: '完成',
            confirmBtn: '确定'
        },
        dialog: [
            '性别是体成分测量的重要依据之一，修改后测量的数据会与以往数据出现差异，请确认是否修改？',
            '身高是体成分测量的重要依据之一，修改后测量的数据会与以往数据出现差异，请确认是否修改？',
            '年龄是体成分测量的重要依据之一，修改后测量的数据会与以往数据出现差异，请确认是否修改？'
        ],
        rules: {
            metricheight: ['请填写范围内身高（2ft3in-6ft7in）'],
            heightMsg: ['请填写范围内身高（70-200cm）'],
            ageMsg: ['请填写范围内年龄（10-99岁）', '填写了非整数：年龄只能为整数，请填写正确的年龄']
        },
        heightMsg: '请重新选择身高',
        ageMsg: '请重新选择年龄',
        ModelBinding: '好像有人捷足先登扫码了呢，请重新测量吧！',
        ReportEmpty: {
            title: '您还没有相关检测报告',
            desc: '找到 Visbody 3D 体测精灵，进行一次测量吧！'
        }
    },
    // 无测量报告
    modelBinding: {
        desc: '好像有人捷足先登扫码了呢，请重新测量吧！'
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: '您还没有相关检测报告',
        desc: '找到 Visbody 3D 体测精灵，进行一次测量吧!',
        descS30: '找到 Visbody-S30 3D 体测精灵，进行一次测量吧！',
        descM30: '找到 Visbody-M30 3D 体测精灵，进行一次测量吧！'
    },
    // 用户信息
    userInfo: {
        height: '身高:',
        age: '年龄:',
        unit: '岁'
    },
    // 体成分
    mass: {
        title: '体成分评估总览',
        titles: '身体成分',
        springFrame: '',
        massFrame: '暂无当天测量数据',
        contrast: '选一份报告对比',
        contrastReport: '选择一份对比报告',
        noRecord: '无记录',
        score: '分',
        status: '您目前的体成分状况',
        WT: '体重',
        PBF: '体脂率',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: '测量值',
            standardRange: '标准范围',
            comparedWithLastLime: '对比上次',
            comparedNet: '对比上次',
            current: '本次测量分数',
            WT: '体重',
            FFM: '去脂体重',
            BFM: '体脂肪',
            LM: '肌肉量',
            TBW: '总水分',
            SM: '骨骼肌',
            PROTEIN: '蛋白质',
            TM: '无机盐',
            BMR: '基础代谢',
            WHR: '腰臀比',
            BMI: 'BMI',
            PBF: '体脂率',
            VFG: '内脏脂肪等级',
            unit: 'kg',
            BMRUnit: 'kcal/d'
        },
        // 定义解读
        explain: [
            {
                title: '体重',
                msg: '体重是身体水分、蛋白质、无机盐和体脂肪的总和。'
            },
            {
                title: '去脂体重',
                msg: '去脂体重是体重扣除脂肪的部分。'
            },
            {
                title: '体脂肪',
                msg: '体脂肪是皮下脂肪，内脏脂肪和肌肉之间脂肪的总和。'
            },
            {
                title: '肌肉量',
                msg: '肌肉量是人体的瘦组织群，包括了骨骼肌、平滑肌和心肌。'
            },
            {
                title: '总水分',
                msg:
                    '身体水分在人体成分中占的含量最多，占体重的50%~70%，身体水分分布于人体细胞和体液中，其中大部分存在于肌肉细胞中。'
            },
            {
                title: '骨骼肌',
                msg: '骨骼肌又称横纹肌，附着在骨骼上的肌肉，肌肉中的一种，此处计算的是骨骼肌的含量。'
            },
            {
                title: '蛋白质',
                msg: '蛋白质是含氮的固态物质，存在于人体所有细胞内，参与细胞构成。是肌肉量的主要成分。'
            },
            {
                title: '无机盐',
                msg: '人体是由有机物、无机物和水组成的，人体里的无机物叫无机盐，无机盐大约占人体重量的5%。'
            },
            {
                title: '基础代谢',
                msg:
                    '基础代谢指人体在清醒而安静的状况下，不受运动、食物、神经紧张、外界温度变化等影响时一天消耗的总能量。'
            },
            {
                title: '腰臀比',
                msg: '腰臀比是腰围和臀围的比值，是判定中心性肥胖的重要指标。'
            },
            {
                title: 'BMI',
                msg: 'BMI主要用于评估外观肥胖度，国际上常作为衡量人体胖瘦程度的标准。'
            },
            {
                title: '体脂率',
                msg: '体脂肪率是指体脂肪占体重的比率。'
            },
            {
                title: '内脏脂肪等级',
                msg: '内脏脂肪等级是评价是否属于隐性肥胖的重要指标。'
            },
            {
                title: '细胞内液',
                msg: '细胞内液：是肌体细胞总体所含的体液，是原生质的基本组成部分。'
            },
            {
                title: '细胞外液',
                msg: '细胞外液：通常指为与细胞外的体液，包括血浆以及介于血管和组织细胞之间的组织间液。'
            },
            {
                title: '骨盆前/后倾',
                msg: '左右髂前上棘点和耻骨联合处形成倒三角面，三角面与地面的垂线的夹角'
            },
            {
                title: '长短腿',
                msg: '背面对比两侧臀线最低点到地面的高度差'
            }
        ],
        // 节段
        segment: {
            fat: '节段脂肪',
            muscle: '节段肌肉',
            right: '右',
            left: '左',
            standard: '标准',
            lowStandard: '低标准',
            superStandard: '高标准'
        }
    },
    // 体态
    shape: {
        title: '体态评估总览',
        titles: '体态评估',
        status: '您目前的体态状况',
        suggest: '建议',
        possibility: '，存在',
        models: {
            front: '正面',
            left: '左侧面',
            right: '右侧面',
            top: '背面',
            low: '偏低',
            high: '偏高',
            normal: '正常'
        },
        item: {
            deviate: '测量值',
            result: '说明',
            normal: '正常',
            abnormal: '异常',
            keAbnormal: '可能异常',
            head: '头前引',
            headSlant: '头侧歪',
            roundShoulderLeft: '左圆肩',
            roundShoulderRight: '右圆肩',
            highLowShoudler: '高低肩',
            pelvis: '骨盆前/后移',
            leftKneeCheck: '左膝评估',
            rightKneeCheck: '右膝评估',
            leg: '腿型',
            leftLeg: '左腿：',
            rightLeg: '右腿：'
        },
        // 定义解读
        explain: [
            {
                title: '头前引',
                msg: '左侧面耳朵点与脖子中心连线和侧面中位线的夹角'
            },
            {
                title: '头侧歪',
                msg: '正面头部中点与脖子中心连线和正面中位线的夹角'
            },
            {
                title: '左圆肩',
                msg: '背部左侧最高点连线和肩部切线的夹角'
            },
            {
                title: '右圆肩',
                msg: '背部右侧最高点连线和肩部切线的夹角'
            },
            {
                title: '高低肩',
                msg: '背面左右肩峰点垂直方向的距离'
            },
            {
                title: '骨盆前/后移',
                msg: '左侧面脖子中心点、髋骨点、脚踝三点连线的夹角'
            },
            {
                title: '左膝评估',
                msg: '左侧面髖骨点、膝关节、脚踝点三点连线的夹角'
            },
            {
                title: '右膝评估',
                msg: '右侧面髖骨点、膝关节、脚踝点三点连线的夹角'
            },
            {
                title: '腿型',
                msg: '左右腿正面髋骨骼点、膝关节、脚踝点连线的夹角'
            },
            {
                title: '骨盆前/后倾',
                msg: '左右髂前上棘点和耻骨联合处形成倒三角面，三角面与地面的垂线的夹角'
            },
            {
                title: '长短腿',
                msg: '背面对比两侧臀线最低点到地面的高度差'
            }
        ],
        exception: [
            {
                title: '偏左',
                abnormal: ''
            },
            {
                title: '偏右',
                abnormal: ''
            },
            {
                title: '左高',
                abnormal: ''
            },
            {
                title: '右高',
                abnormal: ''
            },
            {
                title: '骨盆后移',
                abnormal: ''
            },
            {
                title: '骨盆前移',
                abnormal: ''
            },
            {
                title: '左膝超伸',
                abnormal: ''
            },
            {
                title: '左膝前曲',
                abnormal: ''
            },
            {
                title: '右膝超伸',
                abnormal: ''
            },
            {
                title: '右膝前曲',
                abnormal: ''
            },
            {
                title: 'K型腿',
                abnormal: ''
            },
            {
                title: 'D型腿',
                abnormal: ''
            },
            {
                title: 'X型腿',
                abnormal: ''
            },
            {
                title: 'O型腿',
                abnormal: ''
            },
            {
                title: '骨盆前倾',
                abnormal: ''
            },
            {
                title: '骨盆后倾',
                abnormal: ''
            },
            {
                title: '左长',
                abnormal: ''
            },
            {
                title: '右长',
                abnormal: ''
            }
        ]
    },
    // 围度信息
    girth: {
        title: '体围测量',
        present: '(本次)',
        noHistory: '无数据',
        tpl: [
            {
                title: '颈围',
                key: 'neckGirth'
            },
            {
                title: '左上臂围',
                key: 'leftUpperArmGirth'
            },
            {
                title: '右上臂围',
                key: 'rightUpperArmGirth'
            },
            {
                title: '胸围',
                key: 'bustGirth'
            },
            {
                title: '高腰围',
                key: 'waistGirth'
            },
            {
                title: '中腰围',
                key: 'midWaistGirth'
            },
            {
                title: '臀围',
                key: 'hipGirth'
            },
            {
                title: '左大腿围',
                key: 'leftThighGirth'
            },
            {
                title: '左大腿中部围',
                key: 'leftMidThighGirth'
            },
            {
                title: '左大腿最小围',
                key: 'leftMinThighGirth'
            },
            {
                title: '右大腿围',
                key: 'rightThighGirth'
            },
            {
                title: '右大腿中部围',
                key: 'rightMidThighGirth'
            },
            {
                title: '右大腿最小围',
                key: 'rightMinThighGirth'
            },
            {
                title: '左小腿围',
                key: 'leftCalfGirth'
            },
            {
                title: '右小腿围',
                key: 'rightCalfGirth'
            }
        ]
    },
    // 肩部
    shoulder: {
        title: '肩部功能',
        model: {
            val: '测量值',
            scope: '标准范围',
            diff: '对比上次'
        },
        normal: '正常',
        conclusion: '结论',
        analyse: '分析: ',
        suggest: '建议: ',
        cause: '具体原因请找专业人士做进一步筛查。'
    },
    reportTips: {
        title: '如需删除报告，请联系设备管理员。',
        btnMsg: 'OK',
        alaryTips: '该测量报告已被管理员删除，即将跳转下一份报告！'
    },
    saveQr: {
        title: 'Visbody 3D体测报告',
        btnMsg: '长按图片保存到手机',
        tips: '如发现无法保存，请去【设置】打开相应权限'
    },
    ...zhLocale
}



// WEBPACK FOOTER //
// ./src/assets/js/lang/zh-CN.js